export default "__VITE_ASSET__rOKE2wry__"